// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"j0-z"};